<template>
  <div class="favorites">
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="show-favorites">
            <div class="title-show-favorites">
              <span style="color: white">{{oracle.translate('محصولات مورد علاقه')}}</span>
            </div>
            <div class="list-show-favorites">
              <Placeholder v-if="empty" class="mt-5"></Placeholder>
              <div class="items-show-favorites mt-5" v-else>
                <v-row>
                  <div class="items-show-products-cluna mrx-5">
                    <v-row align="center" justify="center">
                      <div
                          class="itemproduct-fav mrx-5"
                          v-for="(item, index) in favorites"
                          :key="index">
                        <router-link role="button"
                                     :to="{name:'single', query:{id:item.product_id}}">
                          <div class="img-itemproduct-fav mb-2">
                            <img alt="" :src="item.product_icon"/>
                          </div>
                          <div style="text-align: center !important;" class="text-itemproduct-fav text-center">
                            <h6 style="text-align: center !important;" class="multi-line text-center">{{ oracle.product_title(item) }}</h6>
                            <span style="text-align: center !important;" class="font-weight-bold text-center">{{ oracle.format(item.product_sell_price) }} {{oracle.translate('تومان')}}</span>
                          </div>
                        </router-link>
                      </div>
                    </v-row>
                  </div>
                </v-row>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import oracle from "@/oracle";
import Placeholder from "@/components/Placeholder";

export default {
  name: "favorites",
  components: {Placeholder},
  data: () => ({
    empty: false,
    favorites: [],
    oracle: oracle
  }),
  methods: {},
  mounted() {
    oracle.axios(
        "product/getFavorites",
        {"limit_by": 500, "offset_by": 0},
        (response) => {
          this.favorites = response.data
          this.empty = this.favorites.length == 0
        }
    );
  }
};
</script>
<style>
.favorites {
  background: #fff;
}

.favorites .sub-categories-fav {
  min-height: 450px;
  border: 2px solid #7ec352;
  border-radius: 3px;
}

.favorites .title-sub-categories-fav {
  color: #fff;
  line-height: 40px;
  padding: 0 10px;
  font-size: 15px;
  background-color: #7ec352;
}

.favorites .sub-categories-fav ul {
  display: flex;
  padding: 15px;
  font-size: 12px;
  margin: 0;
  flex-direction: column;
}

.favorites .item-sub-categories-fav {
  padding-bottom: 10px;
}

.favorites .item-sub-categories-fav span {
  font-size: 14px;
}

.favorites .item-sub-categories-fav ul {
  padding-right: 15px;
  padding-left: 15px;
}

.favorites .item-sub-categories-fav ul li {
  padding-right: 15px;
  padding-left: 15px;
  line-height: 30px;
  position: relative;
  transition: color ease 0.favorites .2s;
}

.favorites .item-sub-categories-fav > ul li:before {
  content: "•";
  color: #7ec352;
  position: absolute;
  right: 0;
  font-size: 25px;
  line-height: 0;
  top: 19px;
}

.favorites .item-sub-categories-fav ul li a {
  color: #333;
}

.favorites .show-favorites {
  min-height: 400px;
}

.favorites .title-show-favorites {
  background-color: #7ec352;
  color: #fff;
  line-height: 40px;
  padding: 0 10px;
  font-size: 15px;
  border-radius: 3px 3px 0 0;
  border: 2px solid #7ec352;
  border-bottom: 0;
}

.favorites .list-show-favorites {
  min-height: 450px;
}

.favorites .bg-favorites {
  width: 100%;
  height: 500px;
}

.favorites .bg-favorites img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #fff;
}

.favorites #bg-favorites {
  padding: 0;
}

.favorites .itemproduct-fav {
  position: relative;
  text-align: center !important;
  width: 160px;
  margin: auto;
  margin-top: 30px;
}

.favorites .img-itemproduct-fav {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
}

.favorites .img-itemproduct-fav img {
  width: 100%;
  height: 100%;
}

.favorites .text-itemproduct-fav {
  display: flex;
  flex-direction: column;
}

.favorites .items-show-favorites a {
  color: #333;
}

.favorites .text-itemproduct-fav h6 {
  font-size: 13px;
  margin-top: 8px;
}

.favorites .text-itemproduct-fav span {
  font-size: 14px;
  color: #7ec352;
  margin-top: 5px;
}

.favorites .add-to-cart-fav {
  position: absolute;
  top: 5px;
  left: 10px;
}

.favorites .add-to-cart-fav ul {
  display: flex;
  border: 2px solid #7ec352;
  background: #fff;
  border-radius: 25px;
  justify-content: space-between;
  padding: 0 3px !important;
}

.favorites .add-to-cart-fav ul li .favorites .v-icon {
  color: #7ec352;
  font-size: 18px !important;
}

.favorites .add-to-cart-fav ul li:nth-child(2) {
  padding: 0 5px;
}

.favorites .footer-show-favorites {
  margin: 20px 0;
}

</style>
